<template>
  <TabPanel value="monetize">
    <FeatureCard
      span="2"
      title="Convert &amp; Monetize your followers"
      bg-color="secondary"
      color="secondary"
    >
      <VText gutter-bottom>
        Leverage our link in bio tools to convert your followers into paying
        customers.
      </VText>

      <FeatureCardList component="ol">
        <li>Support - tip jar</li>
        <li>Requests</li>
        <li>Forms <Badge content="Pro" /></li>
        <li>Opt-in forms <Badge content="Pro" /></li>
      </FeatureCardList>

      <video
        slot="img"
        src="~/assets/videos/home/monetization.mp4"
        loading="lazy"
        type="video/mp4"
        muted
        loop
        playsinline
        style="aspect-ratio: 16 / 9"
      />
    </FeatureCard>
  </TabPanel>
</template>

<script>
import { VText, TabPanel, Badge } from '@campsite-bio/component-lib';

import FeatureCard from '@/components/features/feature-card';
import FeatureCardList from '@/components/features/feature-card-list';

export default {
  components: {
    VText,
    TabPanel,
    Badge,
    FeatureCard,
    FeatureCardList,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
